import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule, NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../Services/auth.service';
import { MatchingService } from '../Services/matching.service';
import { CustomerInputService } from '../Services/customer-input.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-matching',
  templateUrl: './matching.component.html',
  styleUrls: ['./matching.component.css'],

})
export class MatchingComponent implements OnInit {
  logininfo: Logininfo = this.authService.loginID;

  datail = {
    user_calendar_code: '',
    customer_code: 0,
    customer_name: '',
    interview_place: '',
    content_inquiry: '',
    child_flag: '',
    contact_user_code: '',
    request_code: '',
    request_date1: '',
    request_date2: '',
    request_date3: '',
    tel_number: '',
    mobile_number: '',
    mail_address: '',
  };
  input = {
    customer_code: 0,
    customer_name: '',
    user_code: 0,
    user_name: '',
    interview_date: {
      year: '',
      month: '',
      day: '',
    },
    start_datetime: null,
    start_hour: '',
    start_minute: '',
    end_datetime: null,
    end_hour: '',
    end_minute: '',
    title: '初回面談',
    place: '',
    contents: '',
    child_flag: '',
    user_mail_address: '',
    tel_number: '',
    mobile_number: '',
    mail_address: '',
    overlap_flg: false,
  };
  user_list: {};
  mdl = {
    customer_code: 0,
    request_code: 0,
    customer_name: '',
    start_datetime: null,
    start_hour: null,
    start_minute: null,
    end_datetime: null,
    end_hour: null,
    end_minute: null,
    user_name: '',
    user_code: '',
    user_mail_address: '',
    title: '初回面談',
    place: '',
    contents: '',
    child_flag: '',
    tel_number: '',
    mobile_number: '',
    mail_address: '',
    date_idx: 0,
  };

  result = {
    user_family_name: '',
    user_name: '',
    first_contanct_datetime: '',
    first_contanct_end_datetime: ''
  };
  place_list: any;
  divisions: any;
  users: any;
  sales_users: any;
  construction_users: any;
  message: string;
  error: string;
  tab_class: string;
  fm_flg: string;
  modalReference: NgbModalRef;

  ipt_setHour: number = 8;
  ipt_setMinute: number = 0;
  mdl_setHour: number = 8;
  mdl_setMinute: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public authService: AuthService,
    public matchingService: MatchingService,
    public customerInputService: CustomerInputService,
  ) {

  }

  ngOnInit() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    let List = this.matchingService.matchingDetail(customer_code);
    List.subscribe(List => {
      this.datail = List[0];
      let ListIn = this.matchingService.matchingUserList(this.datail);
      ListIn.subscribe(ListIn => {
        this.user_list = ListIn;
      });
      /*if( this.datail.contact_user_code ){*/
      if (this.datail.customer_code) {
        let ListRes = this.matchingService.matchingResult(this.datail.customer_code);
        ListRes.subscribe(ListRes => {
          this.result = ListRes[0];
        });
      }
      if (this.datail.request_date3) {
        this.tab_class = 'tb3';
      } else {
        this.tab_class = 'tb2';
      }
    });
    //面談履歴：場所表示用
    let place_list = this.customerInputService.placeList(0);
    place_list.subscribe(place_list => {
      this.place_list = place_list;
    });
    //担当者表示用
    let list = this.customerInputService.customerBase(0);
    list.subscribe(list => {
      this.divisions = list['division'];
      this.users = list['user'];
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });
    this.input.user_code = this.authService.getUserCode();
    this.input.user_name = this.authService.getName();
  }

  //モーダル
  open(content, idx_user, idx_date) {
    this.mdl.customer_code = this.datail.customer_code;
    this.mdl.customer_name = this.datail.customer_name;
    this.mdl.user_name = this.user_list[idx_user].user_family_name + '' + this.user_list[idx_user].user_name;
    this.mdl.user_code = this.user_list[idx_user].user_code;
    this.mdl.user_mail_address = this.user_list[idx_user].mail_address;
    this.mdl.date_idx = idx_date;
    this.mdl.title = '初回面談';
    this.mdl.place = this.datail.interview_place;
    this.mdl.contents = this.datail.content_inquiry;
    this.mdl.child_flag = this.datail.child_flag;
    this.mdl.tel_number = this.datail.tel_number;
    this.mdl.mobile_number = this.datail.mobile_number;
    this.mdl.mail_address = this.datail.mail_address;

    const customer_code = +this.route.snapshot.paramMap.get('id');
    this.mdl.customer_code = customer_code;
    if (idx_date == '1') {
      this.mdl.start_datetime = this.datail.request_date1;
      var date = new Date(this.datail.request_date1);
      var date1 = new Date(this.datail.request_date1);
      this.mdl.end_datetime = date.setHours(date.getHours() + 1);
    } else if (idx_date == '2') {
      this.mdl.start_datetime = this.datail.request_date2;
      var date = new Date(this.datail.request_date2);
      var date1 = new Date(this.datail.request_date2);
      this.mdl.end_datetime = date.setHours(date.getHours() + 1);
    } else if (idx_date == '3') {
      this.mdl.start_datetime = this.datail.request_date3;
      var date = new Date(this.datail.request_date3);
      var date1 = new Date(this.datail.request_date3);
      this.mdl.end_datetime = date.setHours(date.getHours() + 1);
    }
    let date2 = new Date(this.mdl.end_datetime);
    var format_str: any = 'YYYY-MM-DD h:m:ss';
    format_str = format_str.replace(/YYYY/g, date2.getFullYear());
    format_str = format_str.replace(/MM/g, date2.getMonth() + 1);
    format_str = format_str.replace(/DD/g, date2.getDate());
    format_str = format_str.replace(/h/g, date2.getHours());
    format_str = format_str.replace(/m/g, date2.getMinutes());
    format_str = format_str.replace(/ss/g, date2.getSeconds());
    this.mdl.end_datetime = format_str;
    var h: any = 'h';
    var m: any = 'm';
    this.mdl.start_hour = h.replace(/h/g, date1.getHours());
    this.mdl.start_minute = m.replace(/m/g, date1.getMinutes());
    this.mdl.end_hour = h.replace(/h/g, date2.getHours());
    this.mdl.end_minute = m.replace(/m/g, date2.getMinutes());
    this.mdlTimeSet();
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(content, config);
    this.modalReference.result.then((result) => { }, (reason) => {
      if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        console.log("BACKDROP_CLICK");
      }
    });
  }

  //マッチング処理：モーダル
  matching_mdl() {
    this.matching(this.mdl);
  }

  //マッチング登録
  matchingAdd() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    this.input.customer_code = customer_code;
    this.input.title = "初回面談";
    this.input.start_datetime = this.input.interview_date.year + "-" + this.input.interview_date.month + "-" + this.input.interview_date.day + " 00:00:00";
    this.input.end_datetime = this.input.start_datetime;
    this.input.tel_number = this.datail.tel_number;
    this.input.mobile_number = this.datail.mobile_number;
    this.input.mail_address = this.datail.mail_address;
    // this.users.forEach(function (value) {
    this.sales_users.forEach(function (value) {
      if (value.user_code == this.input.user_code) {
        this.input.user_name = value.user_family_name + "" + value.user_name;
        this.input.user_mail_address = value.mail_address;
      }
    }, this);
    this.input.overlap_flg = true;
    this.matching(this.input);
  }

  //マッチング処理
  matching(input) {
    //console.log( input );
    let res = this.matchingService.matchingInput(input);
    res.subscribe(res => {
      if (res['state'] == "succes") {
        this.message = "登録が完了しました";
        this.error = "";
        //一覧
        const customer_code = +this.route.snapshot.paramMap.get('id');
        let List = this.matchingService.matchingDetail(customer_code);
        List.subscribe(List => {
          this.datail = List[0];
          let ListIn = this.matchingService.matchingUserList(this.datail);
          ListIn.subscribe(ListIn => {
            this.user_list = ListIn;
          });
          if (this.datail.contact_user_code) {
            let ListRes = this.matchingService.matchingResult(this.datail.customer_code);
            ListRes.subscribe(ListRes => {
              this.result = ListRes[0];
            });
          }
        });
        this.ngOnInit();
      } else if (res['state'] == "overlap") {
        this.message = "";
        this.error = "スケジュールが重複しています";
      } else {
        this.message = "";
        this.error = "更新失敗";
      }
    });
  }

  //マッチングキャンセル
  matchingCan() {
    let res = this.matchingService.matchingCancel(this.result);
    res.subscribe(res => {
      if (res['state'] == "succes") {
        this.message = "キャンセルが完了しました";
        this.error = "";
        //一覧
        const customer_code = +this.route.snapshot.paramMap.get('id');
        let List = this.matchingService.matchingDetail(customer_code);
        List.subscribe(List => {
          this.datail = List[0];
          let ListIn = this.matchingService.matchingUserList(this.datail);
          ListIn.subscribe(ListIn => {
            this.user_list = ListIn;
          });
          if (this.datail.contact_user_code) {
            let ListRes = this.matchingService.matchingResult(this.datail.customer_code);
            ListRes.subscribe(ListRes => {
              this.result = ListRes[0];
            });
          }
        });
        this.ngOnInit();
      } else {
        this.message = "";
        this.error = "更新失敗";
      }
    });
  }

  //戻る
  backMatchingList() {
    this.router.navigate(['/matching-list/']);
  }
  //希望日あり
  mdlTimeSet() {
    //時
    if (this.mdl.start_hour) {
      this.mdl_setHour = this.mdl.start_hour;
    }

    if (this.mdl.start_minute) {
      if (this.mdl.start_minute == 45) {
        this.mdl_setHour = parseInt(this.mdl.start_hour) + 1;
      }
    }

    //分
    if (this.mdl.end_hour) {
      if (this.mdl.end_hour == this.mdl_setHour) {
        if (this.mdl.start_minute == 45) {
          this.mdl_setMinute = 0;
        } else {
          this.mdl_setMinute = parseInt(this.mdl.start_minute) + 1;
        }
      } else {
        this.mdl_setMinute = 0;
      }
    }
  }
  //希望日なし
  iptTimeSet() {
    //時
    if (this.input.start_hour) {
      this.ipt_setHour = parseInt(this.input.start_hour);
    }

    if (this.input.start_minute) {
      if (parseInt(this.input.start_minute) == 45) {
        this.ipt_setHour = parseInt(this.input.start_hour) + 1;
      }
    }

    //分
    if (this.input.end_hour) {
      if (parseInt(this.input.end_hour) == this.ipt_setHour) {
        if (parseInt(this.input.start_minute) == 45) {
          this.ipt_setMinute = 0;
        } else {
          this.ipt_setMinute = parseInt(this.input.start_minute) + 1;
        }
      } else {
        this.ipt_setMinute = 0;
      }
    }
  }

  dp_flg;
  openDp(datePicker) {
    if (this.dp_flg) {
      if (this.dp_flg.isOpen()) {
        if (datePicker == this.dp_flg) {
          this.dp_flg = datePicker;
        } else {
          this.dp_flg.close();
          this.dp_flg = datePicker;
        }
      } else if (datePicker == this.dp_flg) {
        this.dp_flg.close();
        this.dp_flg = "";
      }
    } else {
      this.dp_flg = datePicker;
    }
  }
  closeDp(event) {
    if (this.dp_flg && (event.target.offsetParent == null || event.target.offsetParent.nodeName != "NGB-DATEPICKER")) {
      this.dp_flg.close();
      this.dp_flg = "";
    }
  }
}

